import React from 'react';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Button } from '@tmap/mmm-style-guide/src/Button';
import { ArrowForward } from '@tmap/mmm-style-guide/src/Icon';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';

import IncentiveCard from '../incentiveCard';

const BannerContainer = styled(Grid)(({ theme }) => ({
  height: '100%',
  borderRadius: '8px',
  backgroundColor: theme.palette.primary.veryLight,
  padding: theme.spacing(2.5, 5.5),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3.5, 6),
  },
  fontSize: '18px',
}));

function RelatedOffers(props) {
  const {
    altHeader = 'Find your place.',
    altText = 'Browse all community programs today!',
    buttonText = 'See All Programs',
    incentives = [],
    headerText = incentives?.length > 1 ? 'Related Programs' : 'Related Program',
  } = props;

  if (incentives === null || incentives?.length === 0) {
    return (
      <BannerContainer container alignItems='center'>
        <Grid item xs={12} sm>
          <Typography variant='body1' color='secondary' fontWeight={600}>
            {altHeader}
          </Typography>
          <Typography variant='body1'>
            {altText}
          </Typography>
        </Grid>
        <Grid item xs={12} sm='auto' sx={{ mt: { xs: 2, sm: 0 } }}>
          <Button sx={{ width: '100%', padding: { xs: 'auto', sm: '4px 24px' } }} disableElevation href='/get-paid' variant='contained' color='primary'>
            <Typography fontSize='13px' component='span'>{buttonText}</Typography>
            <ArrowForward sx={{ ml: 1.5, fontSize: '13px' }} />
          </Button>
        </Grid>
      </BannerContainer>
    );
  }

  return (
    <>
      <Typography variant='subtitle1' fontWeight={500} sx={{ mb: 1.25 }}>
        {headerText}
      </Typography>
      <Grid container spacing={2}>
        {incentives?.map((offer, i) => (
          <Grid key={offer._id} item xs={12} md={incentives.length > 1 ? 6 : 12}>
            <IncentiveCard
              incentive={offer}
              variant='contained'
              disableElevation
              color='inverted'
              placementId={`related-offers-${i}`}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default RelatedOffers;
